interface StatusRow {
  uuid: string;
  status: string;
}

/**
 * Whether a fresh read shows a kit asset or a reel that turned `failed` since the read before.
 * A failed asset or reel gives its video credits back (the refund), so the credit box must read
 * the credits again. The first read (`previous` undefined) is not a change: the box reads the
 * credits itself. A failed row that the read before did not hold counts as a change.
 */
export function hasNewFailure(previous: StatusRow[] | undefined, next: StatusRow[]): boolean {
  if (previous === undefined) {
    return false;
  }
  const before = new Map(previous.map((row) => [row.uuid, row.status]));
  return next.some((row) => row.status === 'failed' && before.get(row.uuid) !== 'failed');
}
